<template>
  <div class="rumorWrap">
    <span class="tips">每日辟谣</span>
    <div v-if="!rumourData.complete">
      <div class="question">{{ title }}</div>
      <myAnswer v-if="show" :answer="answer"></myAnswer>
      <div v-else-if="!show && title" class="answer">
        <div class="btn_yes" @click="yesAnswer('是')">是</div>
        <div class="btn_no" @click="yesAnswer('否')">否</div>
      </div>
    </div>
    <div class="wrap_banner">
      <img src="@/assets/images/powderedMilk/milkBanner.png" alt="">
    </div>
    <div v-if="rumourData.complete" class="message">
      <img
          alt=""
          class="message_img"
          src="@/assets/images/powderedMilk/answerComplete.png"
      />
      <div>哎呦，不错哦！您已经解锁本月龄全部问题啦！快来复习一下吧！</div>
    </div>
    <div v-if="rumourData.complete" class="history" @click="ToHistory">
      查看以往问题
      <img
          alt=""
          class="his_more"
          src="@/assets/images/powderedMilk/xiayiye.png"
      />
    </div>
  </div>
</template>
<script>
import Index from "./js/index.js";

export default Index;
</script>
<style lang="less" scoped>
@import "./less/index.less";
</style>